module.exports = __webpack_public_path__ + "static/media/fulllogo.841c3124.jpg";